export default {
  dialogZIndex: 300,
  selectDropdownZIndex: 1000,
  sideNavZIndex: 200,
  drawerBackdropZIndex: 201,
  whiteShadowEffectZIndex: 99999999,
  colorPickerZIndex: 202,
  menuZIndex: 203,
};
